module.exports = __webpack_public_path__ + "img/openbpp2024-1.73537a15.png";